<script setup>
import { useTeljoyLogo } from "~/composables/states";

const logo = useLogo();
const teljoyLogo = useTeljoyLogo();
const css = useCss();
const debug = useDebug();
</script>

<template>
  <div class="flex flex-col h-screen justify-between">
    <header>
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="flex h-16 justify-between">
          <div class="flex flex-shrink-0 items-center">
            <img class="block h-6 lg:h-8 [@media(max-height:600px)]:h-6 w-auto"
                 :src="logo" />
          </div>
          <div class="flex flex-shrink-0 items-center">
            <img class="block h-6 lg:h-8 [@media(max-height:600px)]:h-6 w-auto"
                 :src="teljoyLogo" />
          </div>
        </div>
      </div>
    </header>

    <main class="flex-grow h-min-full">
      <div class="mx-auto h-full max-w-7xl sm:px-6 lg:px-8">
        <div class="h-full px-4 sm:px-0">
          <div class="h-full rounded-lg"
               :class="{ 'border-4 border-dashed border-gray-200': debug }">
            <slot />
          </div>
        </div>
      </div>
    </main>

    <footer>
      <div
           class="mx-auto max-w-7xl py-12 px-4 sm:px-6 md:flex md:items-center md:justify-between lg:px-8">
        <div class="mt-8 md:order-1 md:mt-0">
          <p class="text-center text-base text-gray-400">&copy; {{ new
            Date().getFullYear() }} Teljoy. All
            rights reserved.</p>
        </div>
      </div>
    </footer>

    <link rel="stylesheet"
          type="text/css"
          :href="css" />
  </div>
</template>

<style>
html {
  @apply h-full bg-gray-100;
}

body {
  @apply h-full;
}
</style>
